import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const BackToTopContainer = styled.div`
	position: fixed;
	bottom: 8rem;
	right: 2rem;
	z-index: 9998;
	display: flex;
	flex-direction: column;
	align-items: center;
	opacity: ${(props) => (props.visible ? '1' : '0')};
	visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
	transform: ${(props) =>
		props.visible ? 'translateY(0)' : 'translateY(20px)'};
	transition: all 0.3s ease;

	@media (max-width: 768px) {
		bottom: 12rem;
		right: 1.5rem;
	}
`;

const BackToTopButton = styled.button`
	width: 50px;
	height: 50px;
	background-color: var(--secondary_1);
	border: 1px solid var(--secondary_1);
	border-radius: 50%;
	color: #fff;
	font-size: 1.2rem;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.3s ease;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);

	&:hover {
		background-color: #fff;
		border: 1px solid var(--secondary_1);
		color: var(--secondary_1);
		transform: translateY(-2px);
		box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
	}

	&:focus {
		outline: none;
		box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
	}

	&:active {
		transform: translateY(0);
	}

	@media (max-width: 768px) {
		width: 45px;
		height: 45px;
		font-size: 1.1rem;
	}
`;

const BackToTopText = styled.span`
	font-size: 0.9rem;
	color: var(--primary);
	margin-top: 0.5rem;
	text-align: center;
	font-family: var(--primary_font_family);
	white-space: nowrap;
	font-weight: 500;

	@media (max-width: 768px) {
		font-size: 0.8rem;
		margin-top: 0.4rem;
	}
`;

const BackToTop = () => {
	const [isVisible, setIsVisible] = useState(false);

	// Show button when page is scrolled down
	useEffect(() => {
		const toggleVisibility = () => {
			if (window.pageYOffset > 300) {
				setIsVisible(true);
			} else {
				setIsVisible(false);
			}
		};

		window.addEventListener('scroll', toggleVisibility);

		return () => {
			window.removeEventListener('scroll', toggleVisibility);
		};
	}, []);

	// Scroll to top smoothly
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	};

	return (
		<BackToTopContainer visible={isVisible}>
			<BackToTopButton
				onClick={scrollToTop}
				aria-label='Back to top'
				title='Back to top'
			>
				↑
			</BackToTopButton>
			<BackToTopText>Scroll to Top</BackToTopText>
		</BackToTopContainer>
	);
};

export default BackToTop;
